'use strict';

module.exports = require('./Text');


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-text/lib/index.js
// module id = 235
// module chunks = 0